import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, Paper } from '@mui/material';

import { QueryQuote } from '@tassomutuo-backoffice/types';
import { CtaButton } from '@tassomutuo-backoffice/ui';
import { formatNumberWithThousandsSeparator } from '../../../../utils/formatMoney';
import configEnv from '../../../../config/config';
import QuoteQueriesTableStatusTassoRenderCell from './QuoteQueriesTableStatusTassoRenderCell';
// import QuoteQueryTableRenderCellAction from './QuoteQueryTableRenderCellAction';

interface IProps {
  prodQuoteQueries: QueryQuote[];
  quoteQueries: QueryQuote[];
  onDeleteClick: (row: QueryQuote) => void;
  onPushInProdClick: (row: QueryQuote) => void;
}

const QuoteQueriesTable = ({
  prodQuoteQueries,
  quoteQueries,
  onDeleteClick,
  onPushInProdClick,
}: IProps) => {
  const tableColumns: GridColDef<QueryQuote>[] = [
    {
      field: 'id',
      headerName: 'ID',
      flex: 1,
    },
    {
      field: 'bankName',
      headerName: 'Banca',
      flex: 0.5,
      minWidth: 150,
      valueGetter: ({ row }) => row.queryBody.bank,
    },
    {
      field: 'rateType',
      headerName: 'Tasso',
      flex: 0.5,
      minWidth: 100,
      valueGetter: ({ row }) => row.queryBody.rateType,
    },
    {
      field: 'duration',
      headerName: 'Durata',
      flex: 0.5,
      minWidth: 100,
      valueGetter: ({ row }) => row.queryBody.duration,
    },
    {
      field: 'loanAmount',
      headerName: 'Importo',
      flex: 1,
      valueGetter: ({ row }) =>
        formatNumberWithThousandsSeparator(row.queryBody.loanAmount),
    },
    {
      field: 'propertyValue',
      headerName: 'Valore imm',
      flex: 1,
      valueGetter: ({ row }) =>
        formatNumberWithThousandsSeparator(row.queryBody.propertyValue),
    },
    {
      field: 'age',
      headerName: 'Età',
      valueGetter: ({ row }) => row.queryBody.age,
      flex: 0.5,
      minWidth: 100,
    },
    {
      field: 'purpose',
      headerName: 'Finalità',
      flex: 1,
      valueGetter: ({ row }) => row.queryBody.purpose,
    },
    {
      field: 'tassoStatus',
      headerName: 'Stato Tasso',
      flex: 1,
      renderCell: ({ row }) =>
        QuoteQueriesTableStatusTassoRenderCell({
          queryQuote: row,
          prodQuoteQueries,
        }),
    },
    {
      field: ' ',
      headerName: ' ',
      flex: 1,
      minWidth: 130,
      renderCell: ({ row }) => {
        if (!configEnv.isStage) return null;

        return (
          <CtaButton variant="contained" onClick={() => onPushInProdClick(row)}>
            Pubblica in prod
          </CtaButton>
        );
      },
    },

    /*{
      headerName: ' ',
      field: ' ',
      flex: 0.5,
      sortable: false,
      renderCell: ({ row }) => (
        <QuoteQueryTableRenderCellAction
          onDeleteClick={() => onDeleteClick(row)}
        />
      ),
      minWidth: 100,
    },*/
  ];

  return (
    <Box mt={4}>
      <Paper>
        <DataGrid
          columns={tableColumns}
          rows={quoteQueries}
          disableRowSelectionOnClick
          autoHeight
        />
      </Paper>
    </Box>
  );
};

export default QuoteQueriesTable;
